import { render } from "./DataGridTable.vue?vue&type=template&id=8bef8d12&scoped=true"
import script from "./DataGridTable.vue?vue&type=script&lang=js"
export * from "./DataGridTable.vue?vue&type=script&lang=js"

import "./DataGridTable.vue?vue&type=style&index=0&id=8bef8d12&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bef8d12"]])

export default __exports__